import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useRemoveLanguage = (projectId) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (languageId) => {
      const { data } = await fetchContext.authAxios.delete(
        `/projects/${projectId}/languages/${languageId}`
      );
      return data;
    },
    {
      onSuccess: () => {
        const projectIdStr = projectId?.toString();
        queryClient.invalidateQueries({
          predicate: (query) => {
            const [root, qProjectId, scope] = query.queryKey;
            if (root !== "project") return false;
            if (qProjectId?.toString() !== projectIdStr) return false;
            return (
              scope === "languages" ||
              scope === "info" ||
              scope === "version" ||
              scope === "contributors" ||
              scope === "permissions"
            );
          },
        });
      },
    }
  );
};
